export default (filename: string): string => {
    const periodIndex = filename.lastIndexOf('.');

    if (periodIndex <= 0) return '';

    return filename.substring(0, periodIndex);
};
